// @flow

const LETTER_SPACING = 0;
const FONT_SIZE = 11;
const FONT_WEIGHT = '400';
const FONT_NAME = 'PitchBookFont';

export type FontStyle = {
    fontName?: string,
    fontSize?: number,
    fontWeight?: string,
    letterSpacing?: number,
};

/**
 * @param {string} txt - the string whose width will be returned
 * @param {FontStyle} fontStyle - object, with font settings
 *
 * @returns {number} - width of text
 */
export const getWidthOfText = (txt: string, fontStyle: FontStyle = {}): number => {
    const {
        fontName = FONT_NAME,
        fontSize = FONT_SIZE,
        fontWeight = FONT_WEIGHT,
        letterSpacing = LETTER_SPACING
    } = fontStyle;

    const c = document.createElement('canvas');
    const ctx = c.getContext('2d');

    if (ctx) {
        ctx.font = `${fontWeight} ${fontSize}px ${fontName}`;
    }

    try {
        return ctx ? ctx.measureText(txt).width + (txt.length * letterSpacing) : 0;
    } catch (error) {
        return 0;
    }
};
